(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/manual-redeem/index.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/manual-redeem/index.js');
"use strict";

const {
  VoucherRedeem,
  NeedHelp
} = svs.tur;
const {
  Grid,
  GridCol,
  GridRow
} = svs.ui.ReactGrid;
const ManualRedeem = () => {
  const faultyVoucherId = svs.utils.paramHandler.get({
    key: 'err'
  }).value;
  const onSuccess = voucherCode => {
    svs.utils.url.navigate("".concat(svs.core.data.baseUrl, "/").concat(voucherCode, "?manual=true"));
  };
  return React.createElement(Grid, null, React.createElement(GridRow, {
    className: "u-flex-justify-content-center padding-2"
  }, React.createElement(GridCol, {
    am: 8,
    lg: 4,
    sm: 12
  }, React.createElement(VoucherRedeem, {
    error: Boolean(faultyVoucherId),
    onSuccess: onSuccess,
    voucherId: faultyVoucherId
  }), React.createElement("div", {
    className: "margin-top-2"
  }, React.createElement(NeedHelp, null)))));
};
setGlobal('svs.ticket_gifts.manualRedeem.components.ManualRedeem', ManualRedeem);

 })(window);